import { Components, Theme } from "@mui/material";

export const MuiStep: Components<Theme>["MuiStep"] = {
  styleOverrides: {
    horizontal: {
      paddingLeft: "2px",
      paddingRight: "2px",
    },
  },
};
